import React from 'react'
import PropTypes from 'prop-types'

import { useUpdateCall } from '../../lib/api/update'

export const ProjectEdit = ({ closeEdit, pagesContent, isLocalEnvironment }) => {
  const updateCallMutation = useUpdateCall()
  const [errors, setErrors] = React.useState({})
  const update = async (e) => {
    e.preventDefault()
    if (e.target.websiteName.value === '' || e.target.websiteName.value === null) {
      setErrors({ websiteName: { message: 'Website name is required!' } })
      return
    }
    if (
      errors.websiteName &&
      (e.target.websiteName.value !== '' || e.target.websiteName.value !== null)
    ) {
      delete errors['websiteName']
      setErrors(errors)
    }
    const data = {
      websiteName: e.target.websiteName.value,
      websiteProjectId: pagesContent.websiteProjectId,
      themeId: pagesContent.themeId,
      userId: pagesContent.userId,
      appId: pagesContent.appId,
      tenantId: pagesContent.tenantId,
      websiteProjectNavbar: pagesContent.websiteProjectNavbar,
      websiteProjectFooter: pagesContent.websiteProjectFooter,
      websiteProjectSettings: pagesContent.websiteProjectSettings,
      websiteProjectIsPublished: pagesContent.websiteProjectIsPublished,
    }

    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websiteProjects',
      data: data,
      id: pagesContent.websiteProjectId,
      messageTitle: 'Websites',
      message: 'Website updated!',
      isDynamic: true,
      params: '&isDependency=true',
    })
  }
  return (
    <div
      className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{
        display: 'block',
        backgroundColor: 'rgba(55,55,55,0.3)',
      }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Edit Website
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => closeEdit(false)}
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-row">
              <form className="trtui-row" onSubmit={update}>
                <div className="trtui-col-7">
                  <input
                    type="text"
                    className={`trtui-form-control ${errors.websiteName && 'trtui-is-invalid'}`}
                    placeholder="Website Name"
                    defaultValue={pagesContent.websiteName}
                    name="websiteName"
                  />
                  {errors.websiteName && (
                    <div className="trtui-invalid-feedback">{errors.websiteName.message}</div>
                  )}
                </div>
                <div className="trtui-col-5">
                  <button type="submit" className="trtui-btn trtui-btn-success">
                    Edit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ProjectEdit.propTypes = {
  closeEdit: PropTypes.func.isRequired,
  pagesContent: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
}
